import $ from 'jquery';

/** @var {String} lang */
const lang = $('html').attr('lang');

export default lang;
